import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Details } from '@/core/domain/reservation/models/details.model';
import { DetailsRepository } from '@/core/domain/reservation/repositories/details.repository';

@Injectable({
    providedIn: 'root',
})
export class DetailsImplRepository extends DetailsRepository {
    private detailsSubject: BehaviorSubject<Details> =
        new BehaviorSubject<Details>({ isDetails: false });

    override toggleDetails(): Observable<Details> {
        const currentDetails = this.detailsSubject.value;
        const updatedDetails = { isDetails: !currentDetails.isDetails };
        this.detailsSubject.next(updatedDetails);
        return this.detailsSubject.asObservable();
    }

    override getDetails(): Observable<Details> {
        return this.detailsSubject.asObservable();
    }
}
